<template>
	<Layout>
		<JumbotronCarousel
			v-if="slides.length > 0"
			:slides="slides"
			:alternative-header-active="$arenaConfig.alternativeHeader"
		/>
		<Jumbotron
			v-else
			:bg-image-url="bgImageUrl"
			:main-image-url="mainImageUrl"
			:title="title"
			:special-announcement="false"
		/>
		<div class="l-container">
			<div
				v-for="lane in mixedLanes"
				:key="lane.id"
				class="l-content-section-w js-content-section"
				:class="[
					{
						'-highlighted': lane.highlighted
					},
					`-${lane.lane_type}`
				]"
			>
				<SectionChildNav
					v-if="sports && sports.length && lane.lane_type === ArenaLaneType.NAVIGATION_SPORTS && lane.visible"
					type="sportsCardAlbum"
					:lane-config="lane.config"
					:items="sports"
				/>
				<SectionChildNav
					v-if="leagues.length && lane.lane_type === ArenaLaneType.NAVIGATION && lane.config?.type === 'leagueCardSmall' && lane.visible"
					type="leagueCardSmall"
					:lane-config="lane.config"
					:items="leagues"
				/>
				<SocialLane
					v-if="lane.lane_type === ArenaLaneType.STORIES && lane.visible && socialPosts.length > 0"
					:social-posts="socialPosts"
				/>
				<EventLane
					v-if="lane.visible && lane.storeId"
					:store-id="lane.storeId"
					:album-id="lane.albumId"
					:album-icon="lane.albumIcon"
					:title="lane.title"
					:subtitle="lane.subtitle"
					:more-link="lane.moreLink"
					:lane-type="lane.lane_type"
					:highlighted="lane.highlighted"
					:ad="lane.ad"
				/>
				<AdLane
					v-if="lane.lane_type === ArenaLaneType.AD && lane.visible"
					:ad="lane.ad"
				/>
				<CollectionLane
					v-if="lane.lane_type === ArenaLaneType.COLLECTION && lane.visible"
					:collection="lane.arena_collection"
					:center-horizontally="lane.config?.centerHorizontally || false"
				/>
				<KroneFeaturedNav
					v-if="lane.lane_type === ArenaLaneType.CUSTOM && lane.config?.type === 'kroneFeaturedNav' && lane.visible"
					:config="lane.config"
				/>
			</div>
			<EmptyState
				v-if="noEvents"
				:title="$I18n.trans_choice('commons.event', 2)"
				:text="$I18n.trans('arena.placeholder.replays')"
			/>
		</div>
	</Layout>
</template>

<script>
import Layout from '@js/Views/Layout';
import Jumbotron from '@js/components/Jumbotron';
import JumbotronCarousel from '@js/components/JumbotronCarousel';
import SectionChildNav from '@js/components/SectionChildNav';
import EventLane from '@js/components/EventLane';
import AdLane from '@js/components/AdLane';
import CollectionLane from '@js/components/CollectionLane';
import EmptyState from '@js/components/EmptyState';
import KroneFeaturedNav from '@js/components/KroneFeaturedNav';
import SocialLane from '@js/components/SocialLane';
import { laneMixer } from '@js/utils/laneMixer';
import { ArenaLaneType } from '@shared/enums/ArenaLaneType';
import laroute from '@laroute';

export default {
	name:       'ViewClient',
	components: { Layout, Jumbotron, JumbotronCarousel, SectionChildNav, AdLane, EventLane, CollectionLane, EmptyState, KroneFeaturedNav, SocialLane },
	props:      {
		bgImageUrl: {
			type:    String,
			default: null,
		},
		mainImageUrl: {
			type:    String,
			default: null,
		},
		title: {
			type:    String,
			default: null,
		},
		slides: {
			type:    Array,
			default: () => [],
		},
		sports: {
			type:    Array,
			default: () => [],
		},
		lanes: {
			type:    Array,
			default: () => [],
		},
		ads: {
			type:    Array,
			default: () => [],
		},
		highlightedAd: {
			type:    Object,
			default: null,
		},
		socialPosts: {
			type:    Array,
			default: () => [],
		},
		leagues: {
			type:    Array,
			default: () => [],
		},
	},
	data() {
		return {
			ArenaLaneType,
		};
	},
	computed: {
		noEvents() {
			return this.mixedLanes.filter(lane => !!lane.storeId).every(lane => {
				return this.$store.state.events[lane.storeId].items.length === 0;
			});
		},
		mixedLanes() {
			// get all albums from store
			const albumEntries = Object.entries(this.$store.state.events).filter(([key]) => key.startsWith('album_'));
			const albums = albumEntries.map(([key, value]) => {
				return {
					id:       parseInt(key.replace('album_', '')),
					events:   value.items,
					subtitle: value.subtitle,
					imgUrl:   value.imgUrl,
				};
			});
			return laneMixer(
				albums,
				this.lanes,
				this.$store,
				{
					highlighted: this.highlightedAd,
					normal:      this.ads,
				},
				{
					moreLinks: {
						upcoming: `${laroute.route('arena.video.center.custom')}?eventState=not_ended`,
						replays:  `${laroute.route('arena.video.center.custom')}?eventState=ended`,
					},
					showNavigationLane: this.leagues.length > 0,
				}
			);
		},
	},
};
</script>

<style>

</style>
